<template>
	<div>
		<div class="container page">
			<div class="table-filter-container">
				<select
					v-model="filter.reportCompanyValue"
					class="t-filter-select-company"
					aria-placeholder="ewewe"
				>
					<option value="">Выберите компанию</option>
					<option
						v-for="company in this.allCompany"
						:key="company"
						:value="company"
					>
						{{ company }}
					</option>
				</select>
				<select
					v-model="filter.reportYearValue"
					class="t-filter-select-company"
					aria-placeholder="ewewe"
				>
					<option value="">Выберите год</option>
					<option
						v-for="year in this.allYear"
						:key="year"
						:value="year"
					>
						{{ year.text }}
					</option>
				</select>
				<select
					v-model="filter.reportMonthValue"
					class="t-filter-select-company"
					aria-placeholder="ewewe"
				>
					<option value="">Выберите месяц</option>
					<option
						v-for="month in this.allMonth"
						:key="month"
						:value="month"
					>
						{{ month | getMonth }}
					</option>
				</select>
				<select
					v-model="filter.reportStatusValue"
					class="t-filter-select-company"
					aria-placeholder="ewewe"
				>
					<option value="">Статус</option>
					<option
						v-for="status in this.allStatus"
						:key="status"
						:value="status"
					>
						{{ status }}
					</option>
				</select>
				<button
					class="w-auto block flex sm:inline-flex justify-center items-center gap-2 transition-all ease-in-out duration-150 transform hover:scale-110 bg-blue-500 text-md hover:bg-blue-600 px-10 rounded-lg text-white mx-2"
					@click="changeReportsFilterNotMe()"
				>
					<i class="material-icons">search</i>Поиск
				</button>
			</div>
			<div class="report-actions">
				<form v-if="isApproved" @submit.prevent="downloadExcelMonth">
					<select
						class="download-select"
						required
						v-model="select_month"
					>
						<option value>Выберите месяц</option>
						<option
							v-for="month in this.months"
							:key="month.name"
							:value="month.value"
						>
							{{ month.name }}
						</option>
					</select>
					<button type="submit" class="download-btn">
						Выгрузить в Excel
					</button>
				</form>
			</div>
			<div class="table-container">
				<table>
					<thead>
						<tr>
							<th>№ п/п</th>
							<th>ДЗО</th>
							<th>Отчет создан</th>
							<th>Отчет утвержден</th>
							<th>Год</th>
							<th>Месяц</th>
							<th>Дата создания</th>
							<th>Статус</th>
						</tr>
					</thead>
					<tbody>
						<tr
							v-for="(report, index) in this.reports"
							:key="report.id"
							@click="openReport(report.id)"
						>
							<td>{{ index + 1 }}</td>
							<td>{{ report.dzo.name }}</td>
							<td>
								{{ report.create_user.first_name | TitleCase }}
								{{ report.create_user.last_name | TitleCase }}
							</td>
							<td>
								{{
									report.approved_user
										? report.approved_user.first_name
										: '' | TitleCase
								}}
								{{
									report.approved_user
										? report.approved_user.last_name
										: '-' | TitleCase
								}}
							</td>
							<td>{{ report.year }}</td>
							<td>{{ report.month | getMonth }}</td>
							<td>{{ report.created_datetime | formatDate }}</td>
							<td>
								<p
									class="my-report-status"
									:class="getBtnColor(report.status)"
								>
									{{ report.status }}
								</p>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import { isApproved } from '@/variables';
import { month_options } from '@/variables';
import 'vue-select/dist/vue-select.css';

export default {
	name: 'Reports',
	data() {
		return {
			dzo_id: 'Выберите ДЗО',
			btnColor: 'status-red',
			isApproved: false,
			select_month: '',
			months: '',
			reports: [],
			allReports: [],
			allCompany: '',
			// allYear: '',
			allYear: [
				{ value: 2021, text: '2021' },
				{ value: 2022, text: '2022' },
				{ value: 2023, text: '2023' },
				{ value: 2024, text: '2024' },
				{ value: 2025, text: '2025' },
				{ value: 2026, text: '2026' },
			],
			allMonth: '',
			allStatus: '',
			filter: {
				reportCompanyValue: '',
				reportStatusValue: '',
				reportYearValue: '',
				reportMonthValue: '',
			},
		};
	},
	methods: {
		downloadExcelMonth() {
			let formData = {
				reportId: this.$route.params.id,
				month: this.select_month,
        year: '',
        company: ''
			};
			this.$store.dispatch('downLoadExcel', formData);
		},
		getAllReports() {
			this.$store.dispatch('getAllReportsNotMe').then(response => {
				this.reports = response;
				this.allReports = response;
				this.initializeSet(response);
			});
			this.$store.dispatch('addNotification', {
				type: 'success',
				message: 'Другие отчеты обновлены',
			});
		},
		getAllDzo() {
			this.$store.dispatch('getAllDzo');
		},
		openReport(id) {
			const route = this.$router.resolve({
				name: 'view-report-item',
				params: { id: id },
			});
			window.open(route.href, '_blank');
		},
		getBtnColor(status) {
			let color = '';
			if (status === 'Создан') {
				color = 'status-green';
			} else if (status === 'Подписан исполнителем') {
				color = 'status-yellow';
			} else if (status === 'Подписан утверждающим') {
				color = 'status-yellow';
			} else if (status === 'Утвержден получателем КМГ') {
				color = 'status-blue';
			} else if (status === 'Отклонен утверждающим') {
				color = 'status-red';
			} else if (status === 'Отклонен получателем КМГ') {
				color = 'status-red';
			}
			return color;
		},
		initializeSet(reports) {
			var mySetCompany = new Set();
			var mySetStatus = new Set();
			// var mySetYear = new Set();
			var mySetMonth = new Set();
			for (let i = 0; i < reports.length; ++i) {
				mySetCompany.add(reports[i].dzo.name);
				mySetStatus.add(reports[i].status);
				// mySetYear.add(reports[i].year);
				mySetMonth.add(reports[i].month);
			}
			this.allCompany = mySetCompany;
			this.allStatus = mySetStatus;
			// this.allYear = mySetYear;
			this.allMonth = mySetMonth;
			console.log(this.allYear)
			// this.allYear.add(2023)
			// this.allYear.add(2024)
			
		},
		changeReportsFilterNotMe() {
			var status = this.filter.reportStatusValue;
			var company = this.filter.reportCompanyValue;
			var year = this.filter.reportYearValue.value;
			var month = this.filter.reportMonthValue;
			if (company || status || month || year) {
				this.reports = this.allReports.filter(function(report) {
					return (
						(status ? report.status === status : true) &&
						(company ? report.dzo.name === company : true) &&
						(month ? report.month === month : true) &&
						(year ? report.year === year : true)
					);
				});
			} else {
				this.reports = this.allReports;
			}
		},
	},
	mounted() {
		this.getAllReports();
		this.getAllDzo();
	},
	computed: {
		...mapGetters(['REPORTS', 'ALLDZO', 'USER']),
	},
	created() {
		this.isApproved = isApproved(this.USER.ouser);
		this.months = month_options;
	},
};
</script>

<style scoped>
.page {
	display: flex;
	flex-direction: column;
	min-height: 100vh;
	gap: 2rem;
	padding: 2rem 0;
}

.table-filter-container {
	display: flex;
	justify-content: center;
}

.t-filter-select-company {
	max-width: 300px;
	min-width: 200px;
	height: 60px;
	border: 1px solid #e3e3e3;
	border-radius: 10px;
	appearance: none;
	padding: 1rem 2rem;
	font-size: 1.1rem;
	margin: 0 0.5rem;
}

.t-filter-select-company:focus {
	outline: none;
}

.table-filter-submit {
	width: 200px;
	height: 60px;
	background: #36429e;
	color: #fff;
	border: none;
	outline: none;
	border-radius: 10px;
	font-size: 1.2rem;
	cursor: pointer;
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 1rem;
}

.report-actions {
	display: flex;
	justify-content: flex-end;
}

.download-btn {
	padding: 0.5rem 1rem;
	background: #36429e;
	color: #fff;
	border: none;
	outline: none;
	border-radius: 10px;
	font-size: 1.2rem;
	cursor: pointer;
}

.download-select {
	border: 1px solid #e3e3e3;
	border-radius: 10px;
	appearance: none;
	padding: 0.5rem 2rem;
	font-size: 1.1rem;
	margin: 0 0.5rem 1rem;
}

.download-select:focus {
	outline: none;
}

table {
	border-collapse: collapse;
	width: 100%;
	max-width: 1460px;
	padding: 1rem;
}

thead {
	background: #f3f5ff;
	height: 70px;
}

thead th:nth-child(1) {
	border-top-left-radius: 10px;
}

thead th:nth-child(6) {
	border-top-right-radius: 10px;
}

th {
	padding: 1rem;
	color: #565656;
}

tr {
	cursor: pointer;
}

tr:hover {
	background: #f3f5ff;
}

td {
	padding: 1rem;
	text-align: center;
	border: 1px solid #e3e3e3;
}

.my-report-status {
	/* background: #7AD38D; */
	padding: 0.5rem 2.5rem;
	border-radius: 5px;
	/* width: 180px; */
}

.status-green {
	background: #7ad38d;
	color: white;
}

.status-yellow {
	background: #ffbb56;
	color: white;
}

.status-red {
	background: #e86363;
	color: white;
}

.status-blue {
	background: #1d5ae2;
	color: white;
}
</style>
